var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "notifications-top" }, [
    _c(
      "div",
      {
        staticClass: "errorMessage",
        class: { "errorMessage-visible": _vm.errorIsVisible },
      },
      [
        _c(
          "div",
          { staticClass: "errorMessage-container" },
          [
            _c("svgicon", {
              staticClass: "mg mg--b-1",
              attrs: {
                icon: "alert-circle",
                height: "24",
                width: "24",
                color: "#EC513A",
              },
            }),
            _c(
              "p",
              { staticClass: "mg mg--b-1 text-medium redVidid mg mg--l-1" },
              [_vm._v(_vm._s(_vm.errorMsgGeneral))]
            ),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }